import React, { useState } from "react";
import { ICommonDeleteModalProps } from "./definitions";
import Modal from "@amzn/awsui-components-react/polaris/modal";
import Box from "@amzn/awsui-components-react/polaris/box";
import SpaceBetween from "@amzn/awsui-components-react/polaris/space-between";
import Button from "@amzn/awsui-components-react/polaris/button";

const CommonDeleteModal: React.FC<ICommonDeleteModalProps> = (
  props: ICommonDeleteModalProps,
) => {
  const deleteButtonText = props.deleteButtonText || "Delete";
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      if (props.items) {
        await props.onDelete(props.items);
      } else {
        await props.onDelete();
      }
    } finally {
      setIsDeleting(false);
      props.setVisible(false);
    }
  };

  return (
    <Modal
      onDismiss={() => props.setVisible(false)}
      visible={props.visible}
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button
              variant="link"
              onClick={() => props.setVisible(false)}
              disabled={isDeleting}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleDelete}
              loading={isDeleting}
            >
              {deleteButtonText}
            </Button>
          </SpaceBetween>
        </Box>
      }
      header={props.title}
    >
      <SpaceBetween direction="vertical" size="m">
        <Box />
        <Box>{props.message}</Box>
      </SpaceBetween>
    </Modal>
  );
};

export default CommonDeleteModal;
